import css from 'styled-jsx/css';

const styles = css`.global-layout{padding-top:64px}.global-layout__inner{padding-bottom:60px}.global-layout__inner:not(.width-full){margin:auto}@media screen and (max-width: 767px){.global-layout__inner{padding-bottom:0px}}`;

export default styles;